import { render, staticRenderFns } from "./AgentNeeds.vue?vue&type=template&id=b2fdba1a&"
import script from "./AgentNeeds.vue?vue&type=script&lang=js&"
export * from "./AgentNeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports